import { action, props } from 'ts-action';
import { OptionalHistory } from '../../undo/actions/undo.actions';
import { TagLabel } from '../types/tag.type';
import { Wave, WaveId } from '../types/wave.type';

export const add = action('[Wave] add', props<{ wave: Wave }>());

export const remove = action('[Wave] delete', props<{ waveIds: WaveId[] }>());

export const select = action('[Wave] select', props<{ waveIds: WaveId[] }>());

export const unselectAll = action(
  '[Wave] unselectAll',
  props<OptionalHistory>(),
);

export const toggle = action('[Wave] toggle', props<{ waveIds: WaveId[] }>());

export const moveToBackground = action(
  '[Wave] moveToBackground',
  props<{ waveIds: WaveId[] }>(),
);

export const moveToForeground = action(
  '[Wave] moveToForeground',
  props<{ waveIds: WaveId[] }>(),
);

export const setTags = action(
  '[Wave] setTags',
  props<{ waveIds: WaveId[]; tags: TagLabel[] }>(),
);

export const setWaves = action('[Wave] setWaves', props<{ waves: Wave[] }>());

export const setSavedWaves = action(
  '[Wave] setSavedWaves',
  props<{ waves: Wave[] }>(),
);
